import { Spread } from 'components/BookLayout/buildSpreads';

// Layout-constanten van het paginagrid (gedeeld door PagesGrid en zijn tests).
export const SLOT_WIDTH = 130;
// Ruimte tussen de twee pagina's van één setje (de "rug").
export const SLOT_GAP = 4;
// Ruimte tussen setjes en tussen rijen.
export const SPREAD_GAP = 28;
export const ROW_GAP = 28;
export const GRID_PADDING = 8;

// Verdeelt de setjes in rijen van gelijke lengte. Het grid is gevirtualiseerd per rij (zoals
// de SidesList per item): dikke boeken hebben honderden pagina's en zonder virtualisatie hangen
// er evenveel <img>'s en IntersectionObservers in de DOM.
export const chunkSpreadsIntoRows = (spreads: Spread[], spreadsPerRow: number): Spread[][] => {
  const perRow = Math.max(1, spreadsPerRow);
  const rows: Spread[][] = [];
  for (let i = 0; i < spreads.length; i += perRow) {
    rows.push(spreads.slice(i, i + perRow));
  }
  return rows;
};

// Hoeveel setjes naast elkaar passen in de beschikbare breedte (minimaal 1).
export const calculateSpreadsPerRow = (
  containerWidth: number,
  spreadWidth: number,
  spreadGap: number = SPREAD_GAP,
  padding: number = GRID_PADDING,
): number => {
  const available = containerWidth - padding * 2;
  if (available <= 0) return 1;
  return Math.max(1, Math.floor((available + spreadGap) / (spreadWidth + spreadGap)));
};
